import Cookie from "js-cookie";

export const SEACH_COOKIE = "se:search:shared:state";

const defaultSearchCookie = () => {
  const areas = "";
  const beds = "";
  const baths = "";
  const status = "";
  const bedsOrMoreCheckbox = "";

  return [areas, beds, baths, status, bedsOrMoreCheckbox].join("|");
};

const deserializeSearchCookie = () => {
  const cookieValue = Cookie.get(SEACH_COOKIE) || defaultSearchCookie();
  return cookieValue.split("|");
};

const serializeSearchCookie = value => {
  const cookieValue = value.join("|");
  Cookie.set(SEACH_COOKIE, cookieValue, { path: "/", expires: 365 });
};

export const updateSearchCookie = areas => {
  const areaIds = areas.map(({ id }) => id).join(",");
  const searchValue = deserializeSearchCookie();

  searchValue[0] = areaIds;

  serializeSearchCookie(searchValue);
};

export const getInitialAreas = areaOptions => {
  const searchSharedStateAreas = deserializeSearchCookie()[0];

  if (searchSharedStateAreas) {
    const initialAreaIds = searchSharedStateAreas
      .split(",")
      .map(area => parseInt(area, 10));

    return areaOptions.filter(area => initialAreaIds.includes(area.id));
  }

  return [];
};
